export default __webpack_public_path__ + "static/21_33-09cd3b642e6041c8cbac34492afd4d3a.png";